<template>
    <span class="text-danger" @click="mostrarJustificativa()">
        <i
            class="fa fa-asterisk icon-button"
            :title="`Desp. viagem ajustada: ${despViagem.justificativa}`"
        ></i
    ></span>
</template>

<script>
export default {
    props: {
        despViagem: {
            type: Object
        }
    },
    methods: {
        mostrarJustificativa() {
            this.$swal({
                title: 'Justificativa da Desp. Viagem Ajustada',
                html: this.despViagem.justificativa,
                icon: 'info'
            })
        }
    }
}
</script>
